import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase.ts'
import { QuizRepository } from '@/core/infrastructure/repositories/quiz/QuizRepository.ts'
import { FetchQuizUseCase } from '@/core/useCases/quiz/FetchQuizUseCase.ts'
import { UpdateQuizQuestionsUseCase } from '@/core/useCases/quiz/UpdateQuizQuestionsUseCase.ts'
import { UpdateQuizVersionUseCase } from '@/core/useCases/quiz/UpdateQuizVersionUseCase.ts'
import { MarkQuizAsReadyUseCase } from '@/core/useCases/quiz/MarkQuizAsReadyUseCase.ts'
import { CreateQuizVersionUseCase } from '@/core/useCases/quiz/CreateQuizVersionUseCase.ts'
import { ActivateQuizVersionUseCase } from '@/core/useCases/quiz/ActivateQuizVersionUseCase.ts'
import { ArchiveQuizVersionUseCase } from '@/core/useCases/quiz/ArchiveQuizVersionUseCase.ts'
import { DeleteQuizVersionUseCase } from '@/core/useCases/quiz/DeleteQuizVersionUseCase.ts'
import { QuizVersionRepository } from '@/core/infrastructure/repositories/quiz/QuizVersionRepository.ts'
import { FetchQuizVersionByIdUseCase } from '@/core/useCases/quiz/FetchQuizVersionByIdUseCase.ts'

export class QuizModule extends ModuleBase {
  initialize(): void {
    this.initializeQuiz()
    this.initializeQuizVersion()
  }

  private initializeQuiz(): void {
    const quizRepository = new QuizRepository()

    this.registerRepository(QuizRepository, quizRepository)

    const fetchLearningQuizUseCase = new FetchQuizUseCase(quizRepository)
    const updateLearningQuizQuestionsUseCase = new UpdateQuizQuestionsUseCase(
      quizRepository
    )
    const updateQuizVersionUseCase = new UpdateQuizVersionUseCase(quizRepository)
    const markLearningQuizAsReadyUseCase = new MarkQuizAsReadyUseCase(quizRepository)
    const createQuizVersionUseCase = new CreateQuizVersionUseCase(quizRepository)
    const activateQuizVersionUseCase = new ActivateQuizVersionUseCase(quizRepository)
    const archiveQuizVersionUseCase = new ArchiveQuizVersionUseCase(quizRepository)
    const deleteQuizVersionUseCase = new DeleteQuizVersionUseCase(quizRepository)

    this.registerUseCase(FetchQuizUseCase, fetchLearningQuizUseCase)
    this.registerUseCase(UpdateQuizQuestionsUseCase, updateLearningQuizQuestionsUseCase)
    this.registerUseCase(UpdateQuizVersionUseCase, updateQuizVersionUseCase)
    this.registerUseCase(MarkQuizAsReadyUseCase, markLearningQuizAsReadyUseCase)
    this.registerUseCase(CreateQuizVersionUseCase, createQuizVersionUseCase)
    this.registerUseCase(ActivateQuizVersionUseCase, activateQuizVersionUseCase)
    this.registerUseCase(ArchiveQuizVersionUseCase, archiveQuizVersionUseCase)
    this.registerUseCase(DeleteQuizVersionUseCase, deleteQuizVersionUseCase)
  }

  private initializeQuizVersion(): void {
    const quizVersionRepository = new QuizVersionRepository()

    const fetchQuizVersionByIdUseCase = new FetchQuizVersionByIdUseCase(quizVersionRepository)
    this.registerUseCase(FetchQuizVersionByIdUseCase, fetchQuizVersionByIdUseCase)
  }
}
